import sdk from '@trazi/billingv2/sdk/node';

export default ({ app }, inject) => {
  inject('billingV2SDK', sdk(`${window.location.origin}/api`));
};
